import { loader } from 'graphql.macro'

export default async function addCommentToTicket ({ dataLoaders, variables }) {
  const schema = loader('./addCommentToTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      comment: variables.message,
      ticketId: variables.id
    }
  })

  return response.addCommentToTicket
}
